module.exports = __webpack_public_path__ + "assets/img/cluster-logo-sirius-small-white.svg";